// eslint-disable-next-line
export const passportStringExcludeInvalidChars = /[^А-яёЁ№()\-\\"\/.,\d\s]/
export const paymentAccountRegExp = /^[0-9a-zA-Zа-яёА-ЯЁ]{0,11}$/
